// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6658fefe","453":"0211d0bc","732":"bf2f1c7d","977":"4d2d7db2"}[chunkId] + ".chunk.js";
};